module.exports = __webpack_public_path__ + "img/detection_homonymes.18f4ef66.png";